import { FC } from "react";
import {
  AdminSellBook
} from "Types";

import SellBooksActions from "./SellBooksActions";

interface Props {
  books: AdminSellBook[];
  selectedId: number | null;
  onSelect: (id: number) => void;
  onUpdateStatus: (id: number, status: "Purchased" | "Rejected") => void;
}

const getSellTypeBadge = (sellType?: string) => {
  const base = "px-2 py-1 rounded-full text-xs font-medium";
  switch (sellType) {
    case "Sell":
      return `${base} bg-blue-100 text-blue-800`;
    case "Donate":
      return `${base} bg-purple-100 text-purple-800`;
    default:
      return `${base} bg-gray-100 text-gray-700`;
  }
};

const getStatusBadge = (status: string) => {
  const base = "px-2 py-1 rounded-full text-xs font-medium";
  switch (status) {
    case "Pending":
      return `${base} bg-yellow-100 text-yellow-800`;
    case "Purchased":
      return `${base} bg-green-100 text-green-800`;
    case "Rejected":
      return `${base} bg-red-100 text-red-800`;
    default:
      return base;
  }
};

const SellBooksTable: FC<Props> = ({
  books,
  selectedId,
  onSelect,
  onUpdateStatus,
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border border-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-sm font-semibold">Name</th>
            <th className="px-4 py-3 text-left text-sm font-semibold">
              Mobile
            </th>
            <th className="px-4 py-3 text-left text-sm font-semibold">Book</th>
            <th className="px-4 py-3 text-center text-sm font-semibold">Type</th>
            <th className="px-4 py-3 text-center text-sm font-semibold">
              Status
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold">
              Actions
            </th>
          </tr>
        </thead>

        <tbody>
          {books.length === 0 ? (
            <tr>
              <td colSpan={6} className="py-6 text-center text-gray-500">
                No records found
              </td>
            </tr>
          ) : (
            books.map((book) => (
              <tr
                key={book.id}
                onClick={() => onSelect(book.id)}
                className={`border-b hover:bg-gray-50 ${
                  selectedId === book.id ? "bg-blue-50" : ""
                }`}
              >
                <td className="px-4 py-3 text-sm">{book.fullName}</td>
                <td className="px-4 py-3 text-sm">{book.mobileNumber}</td>
                <td className="px-4 py-3 text-sm">{book.bookTitle}</td>
                <td className="px-4 py-3 text-center">
                  <span className={getSellTypeBadge(book.sellType)}>
                    {book.sellType || "—"}
                  </span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className={getStatusBadge(book.status)}>
                    {book.status}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <SellBooksActions
                    book={book}
                    onUpdateStatus={onUpdateStatus}
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SellBooksTable;
